import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import * as validatorUtility from '@cigna/cigna-for-brokers/shared/util';
import { TranslateService } from '@ngx-translate/core';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { AppstateFacade } from '@cigna/cigna-for-brokers/shell/data-access';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'cigna-cfb-commercial-contractor-box',
  templateUrl: './commercial-contractor-box.component.html',
  styleUrls: ['./commercial-contractor-box.component.scss'],
})
export class CommercialContractorBoxComponent implements OnInit {
  commercialBoxForm: FormGroup;
  countries: string[] = [];
  @Output() cancelClicked = new EventEmitter();
  @Output() continueClicked = new EventEmitter();
  selectedState = this._translate.instant('global.select');
  getFormData$ = this.appstateFacade.getOnBoardingFormData$;
  _ngSubscribe$: Subject<void> = new Subject<void>();
  isExistingOpportunity = false;

  constructor(
    private formBuilder: FormBuilder,
    private _translate: TranslateService,
    private appstateFacade: AppstateFacade,
  ) {
    this.commercialBoxForm = this.formBuilder.group({
      existingOpportunity: ['', Validators.required],
      employerName: [''],
      noOfEligibleEmployees: [''],
      workingState: [
        '',
        [Validators.required, validatorUtility.selectRequiredValidator],
      ],
    });

    const countriesJson = this._translate.instant(
      'onboarding.addressInfo.stateList',
    ) as string[];
    this.countries = [...countriesJson].sort();
  }

  ngOnInit() {
    this.getFormData$.pipe(takeUntil(this._ngSubscribe$)).subscribe((res) => {
      this.commercialBoxForm.patchValue({
        existingOpportunity: res.commercial.isExistingOpportunity,
        employerName: res.commercial.employerName,
        noOfEligibleEmployees: res.commercial.noOfEmployee,
        workingState: res.commercial.workState,
      });
    });
  }

  onContinueClicked() {
    this.isExistingOpportunity = this.commercialBoxForm.get(
      'existingOpportunity',
    )?.value;

    const commecialData = {
      isExistingOpportunity:
        this.commercialBoxForm.get('existingOpportunity')?.value ?? '',
      employerName: this.isExistingOpportunity
        ? this.commercialBoxForm.get('employerName')?.value
        : '',
      noOfEmployee: this.isExistingOpportunity
        ? this.commercialBoxForm.get('noOfEligibleEmployees')?.value
        : '',
      workState: this.commercialBoxForm.get('workingState')?.value ?? '',
    };
    this.appstateFacade.saveCommercialInfo(commecialData);
    this.appstateFacade.saveCommercialContinueFlag(true);

    this.continueClicked.emit();
  }

  onCancelClicked() {
    this.cancelClicked.emit();
  }

  existingOpportunityChanged(hasExistingOpportunity: boolean) {
    this.isExistingOpportunity = hasExistingOpportunity;

    if (hasExistingOpportunity) {
      this.commercialBoxForm
        .get('employerName')
        ?.setValidators(Validators.required);
      this.commercialBoxForm
        .get('noOfEligibleEmployees')
        ?.setValidators([Validators.required, Validators.pattern('^[0-9]*$')]);
    } else {
      this.commercialBoxForm.get('employerName')?.clearValidators();
      this.commercialBoxForm.get('employerName')?.patchValue('');
      this.commercialBoxForm.get('noOfEligibleEmployees')?.clearValidators();
      this.commercialBoxForm.get('noOfEligibleEmployees')?.patchValue('');
    }
    setTimeout(() => this.commercialBoxForm.updateValueAndValidity());
  }

  numberOnly($event: { which: number; keyCode: number }): boolean {
    return validatorUtility.numberOnly($event);
  }
}
